import { useEffect, useState, Fragment, useContext } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { NavLink } from 'react-router-dom'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import { navfunc } from "../../routes/navLinkStylefunc";
import { accountBasePath, accountTeamMemberBasePath, adminMsgBasePath, adminUserBasePath, clientUserBasePath, meetingReqBasePath, programmeDescriptorBasePath, referralBasePath, reportBasePath } from "../../routes/routePaths";
import { getAccessTypes } from "../../hooksAndFunctions/functions/getAccessTypes";
import truncate from "lodash/truncate";
import { Context } from '../../../common/context/Context';

const SidebarMenuList = () => {
    const context = useContext(Context);
    const { isEnterpriseAdmin,
        clientPortalAdminType,
        candidatePortalAdminType,
    } = getAccessTypes()

    const {
        isClientPortalAdmin,
        hasA1Access,
        hasA2Access,
        hasA3Access,
        hasA4Access,
    } = clientPortalAdminType

    const {
        isCandidatePortalAdmin,
        hasCoachAccess    } = candidatePortalAdminType

    const [showCandidatesTab, setShowCandidatesTab] = useState(true)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setShowCandidatesTab(true)
        } else {
            if (!!isCandidatePortalAdmin) {
                setShowCandidatesTab(true)
            } else {
                setShowCandidatesTab(false)
            }
        }
    }, [isEnterpriseAdmin, clientPortalAdminType, candidatePortalAdminType])

    const [showUsersTab, setShowUsersTab] = useState(true)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setShowUsersTab(true)
        } else {
            /**coach can not do any activity */
            if ((!hasCoachAccess) ||
                (!hasCoachAccess && !!hasA1Access) ||
                (!!hasA1Access)
            ) {
                setShowUsersTab(true)
            } else {
                setShowUsersTab(false)
            }
        }
    }, [isEnterpriseAdmin, clientPortalAdminType, candidatePortalAdminType])

    const [showClientsTab, setShowClientsTab] = useState(true)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setShowClientsTab(true)
        } else {
            if (!!isCandidatePortalAdmin) {
                setShowClientsTab(true)
            } else {
                setShowClientsTab(false)
            }
        }
    }, [isEnterpriseAdmin, clientPortalAdminType, candidatePortalAdminType])

    const [showClientPortalSettingsTab, setShowClientPortalSettingsTab] = useState(true)
    useEffect(() => {
        if (!!isEnterpriseAdmin) {
            setShowClientPortalSettingsTab(true)
        } else {
            if (!!isClientPortalAdmin) {
                setShowClientPortalSettingsTab(true)
            } else {
                setShowClientPortalSettingsTab(false)
            }
        }
    }, [isEnterpriseAdmin, clientPortalAdminType, candidatePortalAdminType])



    // const [permitedSidebarRoute, setPermitedSidebarRoute] = useState([])

    // useEffect(() => {
    //     const routelist = !!sidebarRouteArray && sidebarRouteArray.filter((eachItem) => {
    //         if (permissionPages.includes(eachItem.routeTitle)) {
    //             return eachItem
    //         }
    //     })
    //     console.log("gl-my", permitedSidebarRoute)
    //     setPermitedSidebarRoute(routelist)
    // }, [sidebarRouteArray, permissionPages])

    // console.log("gl-my", permitedSidebarRoute)

    /** */
    const [cpsOpen, setCpsOpen] = useState(false);
    const handleClick = () => {
        setCpsOpen(!cpsOpen);
    };

    const fetchNavigationMenuLabel = (key) => {
        if (context?.adminNavigationCmsData?.Components && context?.adminNavigationCmsData?.Components["NavigationMenu"]) {
            const adminFooterCmsData = context?.adminNavigationCmsData?.Components["NavigationMenu"] || []
            return adminFooterCmsData?.Labels.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    const fetchClientPortalSubMenuLabel = (key) => {
        if (context?.adminNavigationCmsData?.Components && context?.adminNavigationCmsData?.Components["ClientPortalSubMenuComponent"]) {
            const adminFooterCmsData = context?.adminNavigationCmsData?.Components["ClientPortalSubMenuComponent"] || []
            return adminFooterCmsData?.Labels.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }
    const hasAccess = isEnterpriseAdmin || hasA1Access || hasA2Access || hasA4Access;

    return (
        <Fragment>
            <ListItemButton component={NavLink} style={navfunc} to={'/dashboard'} sx={{ pl: 3 }}>
                <ListItemText primary={fetchNavigationMenuLabel('NavigationMenu.Dashboard')} />
            </ListItemButton>

            {
                (!!showCandidatesTab) && (
                    <ListItemButton component={NavLink} style={navfunc} to={'/candidates'} sx={{ pl: 3 }}>
                        <ListItemText primary={fetchNavigationMenuLabel('NavigationMenu.Candidates')} />
                    </ListItemButton>
                )
            }

            {
                (!!showUsersTab) && (
                    <ListItemButton
                        component={NavLink}
                        style={navfunc}
                        to={adminUserBasePath}
                        sx={{ pl: 3 }}
                    >
                        <ListItemText primary={fetchNavigationMenuLabel('NavigationMenu.Users')} />
                    </ListItemButton>
                )
            }

            {
                (!!showClientsTab) && (
                    <ListItemButton component={NavLink} style={navfunc} to={'/clients'} sx={{ pl: 3 }}>
                        <ListItemText primary={fetchNavigationMenuLabel('NavigationMenu.Clients')} />
                    </ListItemButton>
                )
            }

            {
                (!!showClientPortalSettingsTab) && (
                    <Fragment>
                        <ListItemButton onClick={handleClick} sx={{ color: "#adb5bd", pl: 3 }} >
                            <ListItemText primary={context?.adminNavigationCmsData?.Components?.["ClientPortalSubMenuComponent"]?.Title} />
                            {cpsOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        <Collapse in={cpsOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                
                                {
                                    hasAccess && (
                                        <ListItemButton component={NavLink} style={navfunc} to={accountBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.ClientAccounts')} />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    hasAccess && (
                                        <ListItemButton component={NavLink} style={navfunc} to={reportBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={
                                                truncate(
                                                    `${fetchClientPortalSubMenuLabel('ClientPortalSubMenu.Reports')}`, {
                                                    'length': 25,
                                                    'omission': "..."
                                                })
                                            } />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    //(!!isEnterpriseAdmin || !!hasA1Access || !!hasA4Access) && ( // allow A2
                                    hasAccess && (
                                        <ListItemButton component={NavLink} style={navfunc} to={programmeDescriptorBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.Resources')} />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    //(!!isEnterpriseAdmin || !!hasA1Access || !!hasA2Access || !!hasA3Access || !!hasA4Access) && (
                                    (isEnterpriseAdmin || hasA1Access || hasA3Access || hasA4Access) && ( // removed access for A2
                                        <ListItemButton component={NavLink} style={navfunc} to={referralBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.Referrals')} />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    hasAccess && (
                                        <ListItemButton component={NavLink} style={navfunc} to={clientUserBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.ClientUsers')} />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    //(!!isEnterpriseAdmin || !!hasA1Access || !!hasA4Access) && (
                                    hasAccess && ( // allow for A2
                                        <ListItemButton component={NavLink} style={navfunc} to={accountTeamMemberBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.AccountTeam')} />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    //(!!isEnterpriseAdmin || !!hasA1Access || !!hasA4Access) && ( // remove A4 access
                                    (isEnterpriseAdmin || hasA1Access) && (
                                        <ListItemButton component={NavLink} style={navfunc} to={adminMsgBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.AdminMessages')} />
                                        </ListItemButton>
                                    )
                                }

                                {
                                    hasAccess && (
                                        <ListItemButton component={NavLink} style={navfunc} to={meetingReqBasePath} sx={{ pl: 4 }}>
                                            <ListItemText primary={fetchClientPortalSubMenuLabel('ClientPortalSubMenu.MeetingRequests')} />
                                        </ListItemButton>
                                    )
                                }
                            </List>
                        </Collapse>
                    </Fragment>
                )}
        </Fragment>
    )
};

export default SidebarMenuList